import { Interval } from 'app/agriculture/AgTimeline/types';
import { clamp as clampDate, isAfter, isWithinInterval } from 'date-fns';

export function getCursorTimeForNewInterval(
    newInterval: Interval<Date>,
    now: Date,
    cursorTime?: Date,
) {
    // If cursorTime is undefined, that means we're in live mode,
    // so if now is still within the interval, then cursorTime should stay undefined
    if (!cursorTime && isWithinInterval(now, newInterval)) return undefined;

    // If the entire interval is in the future no need to check cursor time. It should just be set to "now".
    if (isAfter(newInterval.start, now)) return undefined;

    // Make sure cursor time is in the new interval
    // if it isn't return the interval start or end depending on which side of the interval cursorTime falls outside of
    // if cursor time is undefined, use now instead
    return clampDate(cursorTime ?? now, newInterval);
}
